import { clsx } from 'clsx';
import { useBestellwege } from '@/hooks/useBestellwege';
import { Spinner } from '@/components/ui/Spinner';
// Die Zuordnung Spaltenwert -> Sinnbild steht seit A40 an einer Stelle
// (lib/bestellwegIcons.ts); hier und in QuelleIcon.tsx stand sie zweimal.
import { bestellwegIcon } from '@/lib/bestellwegIcons';

type Props = {
  value: number | null;
  onChange: (id: number) => void;
};

export function BestellwegPicker({ value, onChange }: Props) {
  const q = useBestellwege();
  if (q.isPending) return <Spinner />;
  if (q.isError || !q.data) {
    return <p className="text-sm text-coral">Bestellwege konnten nicht geladen werden.</p>;
  }
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {q.data.items.map((bw) => {
        const Icon = bestellwegIcon(bw.icon);
        const aktiv = value === bw.id;
        return (
          <button
            key={bw.id}
            type="button"
            onClick={() => onChange(bw.id)}
            className={clsx(
              'flex min-h-[44px] flex-col items-center justify-center gap-1 rounded-md border px-3 py-3 text-sm transition-colors',
              aktiv
                ? 'border-akzent bg-akzent text-cream'
                : 'border-line bg-cream text-ink-soft hover:border-akzent hover:text-akzent'
            )}
            aria-pressed={aktiv}
          >
            <Icon className="h-5 w-5" />
            <span>{bw.label}</span>
          </button>
        );
      })}
    </div>
  );
}
